// Error-toned counterpart to `routingRuleset.groupEdit.info`.
export const changeRuleGroupEditTheme = {
  warning: {
    bg: 'palette.error.30',
    borderRadius: '8px',
    text: 'palette.error.95',
  },
};
